import * as NEA from '@spendesk/general-type-helpers/NonEmptyArray';
import React from 'react';

import { ErrorBoundary } from 'common/components/withErrorBoundary';
import { useSupplierDetailsQuery } from 'modules/bookkeep/accounts-payable/hooks/useSupplierDetailsQuery';

import { AccountPayableSuppliersPanel } from './AccountPayableSuppliersPanel';
import { AccountPayableSuppliersPanelLoader } from './AccountPayableSuppliersPanelLoader';
import { useMustDisplayAccountsPayable } from '../../../hooks';
import { type IntegrationStatusWithIntegration } from '../../../integration/status';
import { useBulkArchiveSupplierMutation } from '../../hooks/useBulkArchiveSupplierMutation';
import { useBulkUnarchiveSupplierMutation } from '../../hooks/useBulkUnarchiveSupplierMutation';

type Props = {
  integrationStatus: IntegrationStatusWithIntegration | undefined;
  supplierId: string;
  selectedTab: 'current' | 'archived';
};

export const AccountPayableSuppliersPanelContainer = ({
  integrationStatus,
  supplierId,
  selectedTab,
}: Props) => {
  const supplierDetailsQuery = useSupplierDetailsQuery(supplierId);
  const [bulkArchiveSupplier] = useBulkArchiveSupplierMutation();
  const [bulkUnarchiveSupplier] = useBulkUnarchiveSupplierMutation();
  const mustDisplayAccountsPayable = useMustDisplayAccountsPayable();

  return (
    <ErrorBoundary
      context={{
        team: 'finance-accountant',
        scope: 'account-payables-suppliers',
      }}
    >
      {supplierDetailsQuery.status === 'success' && integrationStatus ? (
        <AccountPayableSuppliersPanel
          integrationStatus={integrationStatus}
          supplier={supplierDetailsQuery.data}
          selectedTab={selectedTab}
          mustDisplayAccountsPayable={mustDisplayAccountsPayable}
          onArchiveSupplier={() =>
            bulkArchiveSupplier({ supplierIds: NEA.fromSingleItem(supplierId) })
          }
          onUnarchiveSupplier={() =>
            bulkUnarchiveSupplier({
              supplierIds: NEA.fromSingleItem(supplierId),
            })
          }
        />
      ) : (
        <AccountPayableSuppliersPanelLoader selectedTab={selectedTab} />
      )}

      <div className="w-[548px]" />
    </ErrorBoundary>
  );
};
